'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIListingPage from 'UIComponents/page/UIListingPage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import DashboardNavigation from 'AdsUI/components/DashboardNavigation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { withRouter } from 'react-router-dom';

const NoCampaign = ({
  network,
  campaignId,
  routes
}) =>
/*#__PURE__*/
// this doesn't really work for sequences, which shouldn't have dashboard navigation. existing issue though.
_jsx(UIListingPage, {
  headerComponent: /*#__PURE__*/_jsx(DashboardNavigation, {
    routes: routes
  }),
  children: /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "notFound",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.detailsErrors.noCampaign",
      options: {
        network: I18n.text(network.toLowerCase()),
        campaignId
      }
    })
  })
});

export default withRouter(NoCampaign);